import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './placement-assignment.redux';

const selectDomain = (state: RootState) => state?.placementMarginAssignment || initialState;

export const selectPlacementMarginTreeViewLookupData = createSelector([selectDomain], state => state?.treeViewData);
export const selectPlacementMarginInsuranceStatus = createSelector([selectDomain], state => state?.insuranceStatus);
export const selectPlacementMarginFurnitureAdjustments = createSelector(
  [selectDomain],
  state => state?.furnitureAdjustments,
);
export const selectPlacementMarginFurnitureEditError = createSelector(
  [selectDomain],
  state => state?.furnitureAdjustmentsError,
);
export const selectPlacementMarginEditTimeOffs = createSelector([selectDomain], state => state?.editTimeOffs);
export const selectPlacementMarginTimeOffGridError = createSelector(
  [selectDomain],
  state => state?.editTimeOffGridError,
);
export const selectPlacementMarginPeopleSoftCalculationResult = createSelector(
  [selectDomain],
  state => state?.peopleSoftResults,
);
export const selectInitialPlacementMarginScenarioMarginDetailsResponse = createSelector(
  [selectDomain],
  state => state?.initialScenarioMarginDetails,
);
